import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { FeedbackFabComponent } from '../components/feedback-fab/feedback-fab.component';
import { BreadcrumbsComponent } from '../components/breadcrumbs/breadcrumbs.component';
import { filter, map, Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { ToastContainerComponent } from '../components/toast-container/toast-container.component';

@Component({
  selector: 'app-layout',
  imports: [
    RouterModule,
    HeaderComponent,
    FeedbackFabComponent,
    FooterComponent,
    BreadcrumbsComponent,
    AsyncPipe,
    ToastContainerComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css',
})
export class LayoutComponent {
  private router = inject(Router);
  protected currentPage$: Observable<string>;

  constructor() {
    this.currentPage$ = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects),
    );
  }
}
